module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-09Equipo-contratista-y-maquinaria-pesada.db5095d9.jpg";